export const PAGE_OPEN = 'page-open'
